import React, {Component} from 'react';
import './App.css';
import {withRouter, Route, Switch, Redirect} from "react-router-dom";
import DeviceManagementPage from "./devicemanagement/DeviceManagementPage";
import {publishCountToCSM} from "./util/Util";
import {DEFAULT_ROUTES} from "./util/RouteConstants";

function publishRoutePath(location) {
    const metricProcessName = "SCC_INDUCT";
    const metricName = location.pathname;
    publishCountToCSM({
        processName: metricProcessName,
        metricName: metricName
    });
}

class App extends Component {
    componentWillMount() {
        publishRoutePath(this.props.location);
        this.onRouteSwitch = this.props.history.listen(() => {
            publishRoutePath(this.props.location);
        });
    }

    componentWillUnmount() {
        this.onRouteSwitch();
    }

    render() {
        return (
            <Switch>
                {Object.keys(DEFAULT_ROUTES).map((path, index) => {
                    return <Route exact path={path} key={index}>
                        <Redirect to={DEFAULT_ROUTES[path]}/>
                    </Route>
                })}
                <Route path="/devicemanagement" component={DeviceManagementPage}/>
            </Switch>
        );
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App.js